var map = {
	"./arrow.svg": "8022",
	"./circle-chart.svg": "d96d",
	"./contact.svg": "7976",
	"./directory.svg": "2b43",
	"./help.svg": "8e40",
	"./home.svg": "9113",
	"./informations.svg": "e95af",
	"./logout.svg": "6137",
	"./message.svg": "f7d2",
	"./news.svg": "9a61",
	"./posiedzenia.svg": "6da1",
	"./question.svg": "1661",
	"./rejestr.svg": "e934",
	"./sms.svg": "0c6f",
	"./user_activiti.svg": "8409"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb95";